import { TextField, Tooltip } from '@arkestro/arkestro-design-system';

import styles from './rename-columns-drawer.module.scss';
import type { EventSettableColumnId } from '@features/event-level-column-rename/types';

interface DisabledColumnFieldProps {
  columnId: EventSettableColumnId;
  disabledFieldTooltipReason: string;
  effectiveLabel: string;
  platformDefaultLabel: string;
}

/**
 * A column the event has switched off: its current effective name, read-only, with the setting
 * that would enable it named in a tooltip. The tooltip listens on the wrapper because a disabled
 * input swallows pointer events. A disabled input cannot take focus either, so the same reason is
 * attached to it as its accessible description for screen readers.
 */
export const DisabledColumnField = ({
  columnId,
  disabledFieldTooltipReason,
  effectiveLabel,
  platformDefaultLabel,
}: DisabledColumnFieldProps) => {
  const tooltipReasonElementId = `column-labels-reason-${columnId}`;

  return (
    <Tooltip title={disabledFieldTooltipReason}>
      <span className={styles.disabledField} data-testid={`column-labels-field-${columnId}`}>
        <TextField
          aria-describedby={tooltipReasonElementId}
          data-testid={`column-labels-input-${columnId}`}
          disabled
          label={platformDefaultLabel}
          value={effectiveLabel}
        />
        <span className={styles.srOnly} id={tooltipReasonElementId}>{disabledFieldTooltipReason}</span>
      </span>
    </Tooltip>
  );
};
